import { ButtonProps, chakra } from '@chakra-ui/react'
import React from 'react'

interface DPNavProps {
  onClick?: () => void
}

const hoverNavButton = { background: 'rgba(0, 0, 0, 0.05)' }
const NavButton: React.FC<ButtonProps> = props => (
  <chakra.button
    _hover={hoverNavButton}
    alignItems="center"
    background="transparent"
    borderRadius="3px"
    cursor="pointer"
    display="flex"
    fontSize="12px"
    justifyContent="center"
    margin="5px"
    padding="11px"
    transition="background-color 0.2s ease-in"
    {...props}
  />
)

export const DPNav: React.FC<DPNavProps> = ({ children, onClick }) => (
  <NavButton
    onClick={e => {
      e.preventDefault()
      onClick && onClick()
    }}
  >
    {children}
  </NavButton>
)
